import { Component, inject } from '@angular/core';
import { WarehouseMaterialStore } from './warehouse-material.store';
import { getWarehouseMaterialsFrag } from './warehouse-material.query';
import { TableColumn } from 'packages/client/src/app/modules/shared/components/kit/table/table.types';
import { WarehouseMaterialOperationTableComponent } from "packages/client/src/app/modules/content/components/services/warehouse-material-operation/warehouse-material-operation-table/warehouse-material-operation-table.component";
import { dateColumn } from 'packages/client/src/app/modules/shared/components/kit/table/table.fields';
import { FolderGlobalStore } from 'packages/client/src/app/store/medicalService/folder.global-store';

@Component({
    selector: 'app-warehouse-material',
    templateUrl: './warehouse-material.component.html',
    providers: [WarehouseMaterialStore, FolderGlobalStore],
    imports: [
        WarehouseMaterialOperationTableComponent,
    ],
})
export class WarehouseMaterialComponent {

    protected readonly store = inject(WarehouseMaterialStore);
    protected readonly folderStore = inject(FolderGlobalStore);

    protected readonly columns: TableColumn[] = [
        dateColumn,
        {
            name: 'warehouseMaterial',
        },
        {
            name: 'amountIssued',
        },
        {
            name: 'amountReturned',
        },
        {
            name: 'work',
        },
        {
            name: 'description',
        },
        {
            name: 'workers',
        },
    ]
    protected readonly getWarehouseMaterialsFrag = getWarehouseMaterialsFrag

}
